






import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RenderMenuMixin } from '@/mixins';
import { AcgnStatisticOverdueDetail, AcgnStaticsMenu } from '@/components';

@Component({
  components: {
    AcgnStatisticOverdueDetail,
    AcgnStaticsMenu
  },
  mixins: [RenderMenuMixin]
})

/**
 * 项目-逾期明细
 */
export default class StatisticStaffOverdueDetail extends Vue {

  private comicId: number = 0; // 漫画id

  private created() {
    this.comicId = parseInt(this.$route.params.id, 0);
  }

  // 渲染左侧菜单
  private renderMenu() {
    return (
      <acgn-statics-menu type="index" isNor={true} comicId={this.comicId}></acgn-statics-menu>
    );
  }
}
